import { ApiSearch } from "@/api/search";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { useStore } from "@/hooks/system/useStore";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useSearchProductsData = () => {
  const searchParams = useSearchParams();
  const { setSelectedFilters } = useStore("search");
  const q = searchParams.get("q");
  const pageNumber = searchParams.get("page_number") || 1;

  useEffect(() => {
    setSelectedFilters({
      q: q || "",
      pageNumber: +pageNumber,
    });
  }, [pageNumber, q, searchParams, setSelectedFilters]);

  const {
    data: searchProducts,
    isLoading,
    isFetching,
  } = useLocalizedQuery({
    queryKey: ["searchProducts", q, +pageNumber!],
    queryFn: async lang => ApiSearch.getSearchProducts({ q, pageNumber: +pageNumber!, lang }),
    options: {
      enabled: !!q,
      placeholderData: prev => prev,
    },
  });

  return { searchProducts, isLoading, isFetching };
};
